import { z } from 'zod/v3';

// Base product version schema
export const ProductVersionDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  version: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isLatest: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
}).strict();

// Create product version
export const CreateProductVersionDTOSchema = z.object({
  version: z.string(),
  name: z.string(),
  description: z.string().optional(),
  isLatest: z.boolean().default(false),
}).strict();

// Update product version
export const UpdateProductVersionDTOSchema = z.object({
  id: z.string(),
  data: z.object({
    name: z.string().optional(),
    description: z.string().optional(),
    isLatest: z.boolean().optional(),
  }).strict(),
}).strict();

// Get product versions query
export const GetProductVersionsQueryDTOSchema = z.object({
}).strict();

// Get product version by ID
export const GetProductVersionByIdDTOSchema = z.object({
  id: z.string(),
}).strict();

// Delete product version
export const DeleteProductVersionDTOSchema = z.object({
  id: z.string(),
}).strict();

// Add topics to product version
export const AddTopicsToProductVersionDTOSchema = z.object({
  versionId: z.string(),
  topicIds: z.array(z.string()),
}).strict();

// Remove topics from product version
export const RemoveTopicsFromProductVersionDTOSchema = z.object({
  versionId: z.string(),
  topicIds: z.array(z.string()),
}).strict();

// Get topics for product version
export const GetProductVersionTopicsDTOSchema = z.object({
  versionId: z.string(),
}).strict();

// Get latest product version
export const GetLatestProductVersionDTOSchema = z.object({
}).strict();

// Export types
export type ProductVersionDTO = z.infer<typeof ProductVersionDTOSchema>;
export type CreateProductVersionDTO = z.infer<typeof CreateProductVersionDTOSchema>;
export type UpdateProductVersionDTO = z.infer<typeof UpdateProductVersionDTOSchema>;
export type GetProductVersionsQueryDTO = z.infer<typeof GetProductVersionsQueryDTOSchema>;
export type GetProductVersionByIdDTO = z.infer<typeof GetProductVersionByIdDTOSchema>;
export type DeleteProductVersionDTO = z.infer<typeof DeleteProductVersionDTOSchema>;
export type AddTopicsToProductVersionDTO = z.infer<typeof AddTopicsToProductVersionDTOSchema>;
export type RemoveTopicsFromProductVersionDTO = z.infer<typeof RemoveTopicsFromProductVersionDTOSchema>;
export type GetProductVersionTopicsDTO = z.infer<typeof GetProductVersionTopicsDTOSchema>;
export type GetLatestProductVersionDTO = z.infer<typeof GetLatestProductVersionDTOSchema>;
